<!--
################################################################################################
######    Vista SVC92000  :  Formulario Pago TPV (Redsys) - Petición Autorización (1/3)   ######
################################################################################################
######         (Pago Directo - Conociendo el valor del PAN / Caducidad / CVC)             ######
################################################################################################
-->

<template>
<div>
  
  <!-- 
  <TNC10000></TNC10000>
  -->

  <!----------------------------------------------------------------------------------->
  <!-------------  Formulario INICIAL para confirmar el PAGO  (FASE 0)----------------->
  <!----------------------------------------------------------------------------------->
  <div v-if="lbMostrarFormularioPago">

    <!--
      <br/><br/>
      <img :src="f99ImageName('logo_ihoreca')" height="96"> 
    -->
    <br/>
    <div class="igs-h4 igs-color1 igs-center">Importe a Pagar</div>
    <br/>

    <div class="row">
      <div class="col-2">&nbsp;</div>
      <div class="col-4 igs-center"><img :src="f99ImageName('ih1-importe-azul')" height="64"></div>
      <div class="col-4 igs-h4 igs-color1 igs-center igs-v-center">{{$store.state.strTPVMensajeImporte}}</div>
      <div class="col-2">&nbsp;</div>
    </div>

    <div><hr/></div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center">Medio de Pago<br/></div>
    </div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center">
        <img :src="f99ImageName('ih1-tarjeta-bancaria-azul')"                 height="64" v-if="!lbOperacionBizum && !lbOperacionAutenticacion">
        <img :src="f99ImageName('ih1-tarjeta-bancaria-autenticacion-azul')"   height="64" v-if="lbOperacionAutenticacion">
        <img :src="f99ImageName('ih1-bizum-azul')"                            height="64" v-if="lbOperacionBizum">
      </div>
    </div>

    <div class="row">
      <div class="col-12 igs-h4 igs-center" v-if="!lbOperacionBizum && !lbOperacionAutenticacion">Tarjeta Bancaria</div>
      <div class="col-12 igs-h4 igs-center" v-if="lbOperacionAutenticacion">Pre-Autorización Bancaria</div>
      <div class="col-12 igs-h4 igs-center" v-if="lbOperacionBizum">Bizum</div>
    </div>

    <div><hr/></div>

    <div class="row" v-if="lbMostrarGuardarTarjeta">
      <div class="col-9 igs-l3 igs-center">
        <label class="form-check-label" for="defaultCheck1">Deseo guardar los datos de la tarjeta para próximas compras</label>
      </div>
      <div class="col-1">&nbsp;</div>
      <div class="col-1 igs-v-center igs-center">
          <input class="form-check-input" style="width:20px; height:20px;" type="checkbox" id="Ds_GuardarTarjeta" ref="rfGuardarTarjeta" @click="lp60GuardarTarjeta()">   
      </div>
      <div class="col-1">&nbsp;</div>
    </div>
    <div v-if="lbMostrarGuardarTarjeta"><hr/></div>

    <!-- Leyenda para "Se va a utilizar la siguiente tarjeta ..." -->
    <div class="row" v-if="lbMostrarTarjetaGuardada">
      <div class="igs-l3 igs-color1 igs-center col-12">Se utilizará la siguiente tarjeta para el pago :</div>
      <div class="igs-l3 igs-color7 igs-center col-12">{{$store.state.strTPVLeyendaDatosTarjeta}}</div>
    </div>
    <div v-if="lbMostrarTarjetaGuardada"><hr/></div>

    <div class="row">
      <div class="col-12 igs-l2 igs-center">Para confirmar el pago pulse el botón PAGAR. <br/></div>
    </div>

    <!--
    <div class="igs-h4 igs-color2 igs-center">{{$store.state.strTPVMensajeTitulo}}</div>
    <div class="igs-h3 igs-color1 igs-center">{{$store.state.strTPVMensajeSubtitulo}}</div>
    -->

    <br/>

    <form ref="TPVRedSys" id="TPVRedSys" :action="ltURL" method="POST">
        <input type="hidden" name="Ds_SignatureVersion"     :value="ltSignatureVersion" />
        <input type="hidden" name="Ds_MerchantParameters"   :value="ltMerchantParameters" />
        <input type="hidden" name="Ds_Signature"            :value="ltSignature" />
        <input type="button" value="Pagar" class="btn btn-lg btn-outline-dark" ref="TPVRedSys_Enviar" @click="lp71IniciarPeticionREST()">
        <!--<input type="submit" value="Submit" class="btn btn-lg btn-outline-dark" ref="TPVRedSys_Submit">-->
    </form>      
        <!-- <a href="" ref="TPVRedSys_Enviar" @click="lp70Submit()">Pagar</a> -->      
  </div>

  <!--
  <div>
      <div><h3>ltURL</h3>{{ltURL}}</div>
      <div><h3>SignatureVersion</h3>{{ltSignatureVersion}}</div>
      <div><h3>MerchantParameters</h3>{{ltMerchantParameters}}</div>
      <div><h3>Signature</h3>{{ltSignature}}</div>
  </div>
  -->


    <!----------------------------------------------------------------------------------->
    <!---------------------- Formulario de "Error" (cualquier Fase)  -------------------->
    <!----------------------------------------------------------------------------------->
    <div v-if="lbMostrarFormularioError">
      <br/>
      <div class="igs-h5 igs-center" style="color:red">Error</div>
      <br/>

      <div class="row">
        <div class="col-12"><hr/></div>
        <div class="col-12 igs-h4 igs-center igs-v-center"><br/>Código <span style="color:red">{{ ltCodigoError }}</span></div>
        <div class="col-12 igs-h4 igs-center igs-v-center"><br/>{{ltDescripcionError}}</div>
        <div class="col-12">&nbsp;</div>
      </div>
    </div>

    <!-- Formulario "Challenge" -->
    <div v-if="lbMostrarFormularioChallenge">
      <h3>Solicitando Autorización a la Plataforma de Pago</h3>
      <form :action="ltURLChallenge" method="POST" enctype ="application/x-www-form-urlencoded">
        <input type="hidden" name="creq" :value="ltCREQChallenge">
        <input type="submit" value=" Enviando solicitud ...." class="btn btn-lg btn-outline-dark" ref="TPVRedSys_Submit_CREQ">
      </form>

    </div>


    <!---------------------------------------------------------------------------------------------------------->
    <!-- Formulario mostrado en la FASE FINAL, cuando se procede a CONFIRMAR la Operacion TRAS el "Challenge" -->
    <!-------------------------------         Mostrado en la Etapa (5)   --------------------------------------->
    <!---------------------------------------------------------------------------------------------------------->
    <div v-if="lbMostrarFormularioPreConfirmacion">
          <!-- <img :src="f99ImageName('ih1-ok-azul')"             height="96"> -->
          <br/>

          <div class="igs-h2 igs-color2">Esperando Confirmación ...</div>

          <br/>

          <div class="row">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Referencia</div>
            <div class="col-md-5 igs-h3 igs-color1">{{ltReferenciaPedido}}</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 

          <!--
          <div class="row">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Código de Autorización</div>
            <div class="col-md-5 igs-h3 igs-color1">{{ltCodigoAutorizacion}}</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 
          -->

          <div class="row">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Importe</div>
            <div class="col-md-5 igs-h3 igs-color1">{{f91Cantidad(lnImportePago)}} €</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 
    </div>



    <!----------------------------------------------------------------------------------->
    <!-- Formulario de Confirmación de la Operación (una vez recibido el OK de RedSys) -->
    <!---------------------------  Mostrado en la Etapa (9) ----------------------------->
    <!----------------------------------------------------------------------------------->
    <div v-if="lbMostrarFormularioOperacionConfirmada">
          <br/>

          <div class="igs-h4" style="color:#009900" v-if="ltMensajeError == 'EXITO'">Operación APROBADA</div>
          <div class="igs-h4" style="color:#ff0000" v-if="ltMensajeError != 'EXITO'">Operación RECHAZADA</div>

          <br/>

          <div class="row">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Número de Pedido</div>
            <div class="col-md-5 igs-h3 igs-color1">{{ltReferenciaPedido}}</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 

          <div class="row" v-if="ltMensajeError == 'EXITO'">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Código de Autorización</div>
            <div class="col-md-5 igs-h3 igs-color1">{{ltCodigoAutorizacion}}</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 

          <div class="row" v-if="ltMensajeError == 'EXITO'">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Importe Pagado</div>
            <div class="col-md-5 igs-h3 igs-color1">{{f91Cantidad(lnImportePago)}} €</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 

          <div class="row" v-if="ltMensajeError != 'EXITO'">
            <div class="col-md-1">&nbsp;</div>
            <div class="col-md-5 igs-h3 igs-color2">Descripción del Error</div>
            <div class="col-md-5 igs-h3 igs-color1">{{ltMensajeError}}</div>
            <div class="col-md-1">&nbsp;</div>
          </div> 


    </div>

    <div id="t097m001" style="display:none" v-if="lbMostrarFormularioOperacionConfirmada">
    { "t097m001" : {
                "tkey" : "92000",
                "tmsg" : "{{ltMensajeError}}",
                "t901" : "{{ltReferenciaPedido}}",
                "t902" : "{{ltCodigoError}}",
                "t903" : "{{ltCodigoTienda}}",
                "t904" : "{{ltCodigoTerminal}}",
                "t905" : "{{ltTipoTransaccion}}",
                "t906" : "{{ltCodigoAutorizacion}}",
                "t907" : "{{ltFechaAutorizacion}}",
                "t908" : "{{ltHoraAutorizacion}}",
                "t909" : "{{ltTipoTarjeta}}",
                "t910" : "{{ltPaisTarjeta}}",
                "t911" : "{{ltMonedaOperacion}}",
                "t912" : "{{ltImporteOperacion}}",
                "t913" : "{{ltReferenciaERP}}",
                "t914" : "{{ltPagoSeguro}}",
                "t915" : "{{ltPANTarjeta}}",
                "t916" : "{{ltCaducidadTarjeta}}",
                "t917" : "{{ltIdentificadorTarjeta}}",
                "t918" : "{{ltIdiomaUsuario}}"
        }
    }
    </div>

  <!--
  <BNC10000></BNC10000>
  -->

</div>
</template>

<script>
import igs_mixin from '@/igs-mixins/igs_mixin'
const  axios = require("axios")

//import TNC10000  from '@/igs-navegacion/TNC10000'
//import BNC10000  from '@/igs-navegacion/BNC10000'

export default {
  mixins: [ igs_mixin ],
  //components : { TNC10000, BNC10000 },

  //=======================================================================
  //------------------------ Variables Locales  ---------------------------
  //=======================================================================
  el : "#formRoot",

  data() {
    return {
        lSWModoProduccion                       : false,
        ltSignatureVersion                      : '',
        ltMerchantParameters                    : '',
        ltSignature                             : '',
        ltURL                                   : '',
        ltGuardarTarjeta                        : '0',
        ltSavedTPVMerchantIdentifier            : '',

        ltCodigoError                           : '',
        ltDescripcionError                      : '',
      
        ltURLChallenge                          : '',
        ltCREQChallenge                         : '',

        ltMensajeError                          : '',
        ltCodigoTienda                          : '',
        ltCodigoTerminal                        : '',
        ltTipoTransaccion                       : '',
        ltFechaAutorizacion                     : '',
        ltHoraAutorizacion                      : '',
        ltTipoTarjeta                           : '',
        ltPaisTarjeta                           : '',
        ltMonedaOperacion                       : '',
        ltImporteOperacion                      : '',
        ltReferenciaERP                         : '',
        ltPagoSeguro                            : '',
        ltPANTarjeta                            : '',
        ltCaducidadTarjeta                      : '',
        ltIdentificadorTarjeta                  : '',
        ltIdiomaUsuario                         : '',
        ltReferenciaPedido                      : '',
        ltCodigoAutorizacion                    : '',
        lnImportePago                           : 0,

        lbOperacionBizum                        : false,
        lbOperacionAutenticacion                : false,
        lbMostrarGuardarTarjeta                 : false,
        lbMostrarTarjetaGuardada                : false,
        
        lbMostrarFormularioPago                 : false,
        lbMostrarFormularioError                : false,
        lbMostrarFormularioChallenge            : false,
        lbMostrarFormularioPreConfirmacion      : false,
        lbMostrarFormularioOperacionConfirmada  : false,
    }
  },

  //=======================================================================
  //------------------------ Variables Calculadas  ---------------------------
  //=======================================================================
  computed : {

    //-----------------------------------------------
    //-- Dirección Completa de la Página Actual
    //-----------------------------------------------
    lt91URLCompleta() {
      return window.location.href;
    }

  },


  //=======================================================================
  //------------------------ Métodos Locales  ---------------------------
  //=======================================================================
  methods: {

    //--------------------------------------------------------------------------------
    //-- Animación Inicial al Mostrar la Página de Login
    //--------------------------------------------------------------------------------
    // eslint-disable-next-line no-unused-vars
    onPageLoaded (args) {

      //-- Ocultar Indicadores de Actividad
      this.$store.commit('p10StrRecibiendoDatos', false);

    },


    //--------------------------------------------------------------------------------
    //-- Iniciar una Nueva Transacción (TPV Redsys)
    //--------------------------------------------------------------------------------
    lp50IniciarTransaccion() {

        //console.log('-- Inicio Petición Autorización --');

        //-- Mostrar Formulario Inicial para el PAGO
        this.lbMostrarFormularioPago = true;

        //-- Recursos Necesarios
        const {
            Redsys,
            SANDBOX_URLS,
            PRODUCTION_URLS,
            TRANSACTION_TYPES,
            //randomTransactionId
        } = require('redsys-easy')

        //-- Extraer valores a utilizar en este Método
        var indiceTPV             = this.$store.state.strT001M030_Indice;  // Valores : 1, 2, ..., n
        if (indiceTPV > 0) { indiceTPV = indiceTPV - 1; }                  // Aplicar : 0, 1, ..., n-1

        var secretTPV             = this.f75DesofuscarTexto(this.$store.state.strT001M030[indiceTPV].secretComercio);
        var codigoComercioTPV     = this.$store.state.strT001M030[indiceTPV].codigoComercio;
        var terminalComercioTPV   = this.$store.state.strT001M030[indiceTPV].terminalComercio;
        var urlConfirmacionOnline = this.$store.state.strT001M030[indiceTPV].urlConfirmacionOnline.replace('redsys','rest');

        //-- Valores Específicos del Pedido
        var referenciaPedido      = this.$store.state.strReferenciaPedido;
        var importePedido         = this.$store.state.strImportePedido;

        console.log(' codigoComercio : '+codigoComercioTPV);
        console.log(' terminalComercio : '+terminalComercioTPV);
        console.log(' secretTPV : '+secretTPV);
        console.log(' ReferenciaPedido : '+referenciaPedido);
        console.log(' ImportePedido : '+importePedido);

        //-- URLs TPV Virtual : Prueba ó Producción
        var URLsTPV   = SANDBOX_URLS;
        if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  URLsTPV = PRODUCTION_URLS; }

        //-- Comenzar la creación del OBJETO a enviar al TPV
        const redsys = new Redsys({
            secretKey:  secretTPV,
            urls:       URLsTPV, 
        });

        //-- Aplicar el parámetro adecuado cuando se AUTORIZA CONSERVAR la TARJETA para (Uso Futuro)
        if (this.ltGuardarTarjeta == '1') {
          this.$store.commit('p10StrTPVMerchantIdentifier', 'REQUIRED');
        } else {
          this.$store.commit('p10StrTPVMerchantIdentifier', this.ltSavedTPVMerchantIdentifier);
        }

        //-- Componer los valores oportunos para el "merchantData"
        var merchantData = this.$store.state.strDistribuidor + this.$store.state.strUsuario + 'C' + this.$store.state.strCliente + 'R' + this.$store.state.strReferenciaPedido + 'M' + this.ltGuardarTarjeta + 'I' + this.$store.state.strImportePedido;

        if (urlConfirmacionOnline != '') {
          merchantData = this.$store.state.strDistribuidor + this.$store.state.strUsuario + 
                                  'C' + this.$store.state.strCliente + 'R' + this.$store.state.strReferenciaPedido + 
                                  'M' + this.ltGuardarTarjeta + 'I' + this.$store.state.strImportePedido + '|' +
                                  's='+this.$store.state.strIDSesion+
                                  '&u='+this.$store.state.strUsuario+
                                  '&d='+this.$store.state.strDistribuidor+
                                  '&c='+this.$store.state.strCliente+
                                  '&t=230&m=911'+
                                  '&n='+this.$store.state.strNifClienteOfuscado+
                                  '&x='+this.$store.state.strReferenciaPedido;
        }

        //console.log(merchantData);

        //-- Determinar el Tipo de Transacción
        var tipoTransaccion = TRANSACTION_TYPES.AUTHORIZATION;                                                                           //-- (0)=Autorización Inmediata

        if (this.$store.state.strTPVMerchantPayMethods == '1') { tipoTransaccion = TRANSACTION_TYPES.PRE_AUTHORIZATION; }                //-- (1)=Solicitud    Pre-Autorización  para Cargo Posterior (Con Bloqueo de Importe)
        if (this.$store.state.strTPVMerchantPayMethods == '2') { tipoTransaccion = TRANSACTION_TYPES.CONFIRMATION; }                     //-- (1)=Confirmación Pre-Autorización  para Cargo Posterior (Operación Firme)
        if (this.$store.state.strTPVMerchantPayMethods == '9') { tipoTransaccion = TRANSACTION_TYPES.PRE_AUTHORIZATION_CANCEL; }         //-- (9)=Cancelación  Pre-Autorización  para Cargo Posterior (Liberación del Bloqueo Inicial)
                                                                                  
        if (this.$store.state.strTPVMerchantPayMethods == '7') { tipoTransaccion = TRANSACTION_TYPES.PRE_AUTHENTICATION; }                //-- (7)=Solicitud    Pre-Autenticación para Cargo Posterior (Sin Bloqueo de Importe)
        if (this.$store.state.strTPVMerchantPayMethods == '8') { tipoTransaccion = TRANSACTION_TYPES.PRE_AUTHENTICATION_CONFIRMATION; }   //-- (8)=Confirmación Pre-Autenticación para Cargo Posterior (Operación Firme)

        //-- Debug
        //console.log('codigoComercio (FUC) :'+codigoComercioTPV);
        //terminalComercioTPV = '999';

        //-- Extraer Datos de la Tarjeta
        let txtDatosTarjeta = this.f75DesofuscarTexto(this.$store.state.strTPVMensajeTitulo);
        var aDatosTarjeta = txtDatosTarjeta.split("^");
        let tPAN       = aDatosTarjeta[0];
        //let tExpiry  = aDatosTarjeta[1];
        //let tCVV     = aDatosTarjeta[2];

        const obj = {
            amount: importePedido,                                          //-- Importe (en Céntimos de Euro)
            currency: 'EUR',                                                //-- Moneda
            order: referenciaPedido,                                        //-- Número de Referencia               
            merchantCode: codigoComercioTPV,                                //-- Código de la Tienda / Comercio
            terminal: terminalComercioTPV,                                  //-- Número de Terminal
            transactionType: tipoTransaccion,                               //-- Tipo de Transacción

            pan : tPAN,
            //expiryDate : tExpiry,
            //cvv : tCVV,            
            EMV3DS : '{"threeDSInfo":"CardData"}',

            raw: {  
              //-- Referencia Adicional (Texto Libre, como referencia para el Comercio)
              DS_MERCHANT_MERCHANTDATA: merchantData,

              //-- Bizum : Debe incluirse el valor (z) dentro de DS_MERCHANT_PAYMETHODS 
              DS_MERCHANT_PAYMETHODS: this.$store.state.strTPVMerchantPayMethods,

              //-- Visa, MasterCard, ... 
              //--  ""         : Interfaz habitual, con introducción del PAN, Caducidad, CVC, CIP, ...
              //--  "REQUIRED" : Interfaz habitual + Solicitud de respuesta incluyendo IDENTIFICADOR para uso Futuro en modo 1-Click
              //--  "otro valor" : Valor del IDENTIFICADOR recibido cuando se solicitó la operación en modo "REQUIRED"
              DS_MERCHANT_IDENTIFIER: this.$store.state.strTPVMerchantIdentifier
            }
        }

        //-- Composición de la Peticion REST
        const result = redsys.RESTPetition(obj);
        //console.log(result);

        //-- Establecer Valor para las variables del Formulario
        this.ltURL                  = result.url;
        this.ltSignatureVersion     = result.body.Ds_SignatureVersion;
        this.ltMerchantParameters   = result.body.Ds_MerchantParameters;
        this.ltSignature            = result.body.Ds_Signature;

        //-- La CONFIRMACIÓN ó CANCELACIÓN de una "Pre-Autorización" y/o "Pre-Autenticación" no requiere PAUSA para que el usuario confirme la operación
        if ((this.$store.state.strTPVMerchantPayMethods == '2') || (this.$store.state.strTPVMerchantPayMethods == '8') || (this.$store.state.strTPVMerchantPayMethods == '9')) {
          //this.$refs.TPVRedSys_Enviar.click();
          setTimeout(() => {  this.$refs.TPVRedSys_Enviar.click(); }, 100);
        }

    },

    //------------------------------------------------------
    //-- Conmutar valor de la Check "Guardar Tarjeta"
    //------------------------------------------------------
    lp60GuardarTarjeta() {

      //-- Conmutar y Conservar el Valor de la "CheckBox"
      if (this.ltGuardarTarjeta == '0') {
        this.ltGuardarTarjeta                 = '1';
        this.$refs.rfGuardarTarjeta.checked   = true;
      } else {
        this.ltGuardarTarjeta                 = '0';
        this.$refs.rfGuardarTarjeta.checked   = false;
      }

      //-- Recalcular Transacción
      this.lp50IniciarTransaccion();

      //console.log(' lp60GuardarTarjeta : '+this.ltGuardarTarjeta);
    },


    //---------------------------------------------------------------------------------
    //-- REST (1) - Iniciar Transacción (solicitando el Inicio de la Peticion REST)
    //---------------------------------------------------------------------------------
    lp71IniciarPeticionREST() {
      
      //-- Valores Específicos del Pedido
      var referenciaPedido      = this.$store.state.strReferenciaPedido;
      var importePedido         = this.$store.state.strImportePedido;

      //-- Crear la URL para solicitar el Inicio de la Peticion
      let parametros = this.f75OfuscarTexto(this.ltURL+"|"+this.ltSignatureVersion+"|"+this.ltMerchantParameters+"|"+this.ltSignature+'|'+this.lt91URLCompleta);
      let URL = global.lnkServerRestURL+"s="+this.$store.state.strIDSesion+"&d="+this.$store.state.strDistribuidor+"&u="+this.$store.state.strUsuario+'&r='+encodeURIComponent(referenciaPedido)+'&i='+encodeURIComponent(importePedido)+'&x='+encodeURIComponent(parametros);
      console.log(URL);

      //-- Mostrar el/los indicadores de actividad oportunos
      this.$store.commit('p10StrRecibiendoDatos', true);
        
      //-- Solicitud de Datos al Servidor 
      axios.get(URL, {responseEncoding: 'utf-8'})
      .then(respuesta => {
      
            //console.log('Respuesta : ');
            //console.log(respuesta.data);

            //-- Desactivar los Indicadores de Actividad
            this.$store.commit('p10StrRecibiendoDatos', false);

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si el contenido es el correcto
            if (datos.ic1_rest) {
              /*
              console.log('EXITO');
              console.log('------------------');
              console.dir(datos.ic1_rest);
              console.log('------------------');
              */

              //-- Determinar si se ha recibido en mensaje CON ERRORES
              if (datos.ic1_rest.m001_codigoError == '') {

                //-- Extraer los 3 valores recibidos
                //let m001_Signature = datos.ic1_rest.m001_Signature;
                //let m001_Signature_Version = datos.ic1_rest.m001_Signature_Version;
                let m001_Merchant_Parameters = JSON.parse(this.f75DesofuscarTexto(datos.ic1_rest.m001_Merchant_Parameters));

                //-- Debug
                /*
                console.log('---------- A -------------');
                console.log(' m001_Signature : '+m001_Signature);
                console.log(' m001_Signature_Version : '+m001_Signature_Version);
                console.log('-- m001_Merchant_Parameters --');
                console.dir(m001_Merchant_Parameters);
                console.log('---- Fin A ----');
                */

                //-- (2)-Petición Autorización
                this.lp72PeticionAutorizacionREST(referenciaPedido,importePedido,m001_Merchant_Parameters);
              } else {
                //-- Preparativos para mostrar el ERROR
                this.ltCodigoError            = datos.ic1_rest.m001_codigoError;
                this.ltDescripcionError       = datos.ic1_rest.m001_descripcionError;

                //-- Mostrar Mensaje de Error
                this.lbMostrarFormularioPago  = false;
                this.lbMostrarFormularioError = true;
              }

            } else {
                this.p99AnuncioIH1('2','7','ERROR', 'Error TPV92000-A<br/>'+respuesta.data.msg,-1);
            }
                
      })
      .catch(error => {
          //-- Desactivar los Indicadores de Actividad
          this.$store.commit('p10StrRecibiendoDatos', false);

          //-- Mostrar el Mensaje de Error oportuno
          this.p99AnuncioIH1('2','7','ERROR', error.message,-1);
      });

    },



    //------------------------------------------------------
    //-- REST (2) - Peticion de Autorización para el CARGO
    //------------------------------------------------------
    lp72PeticionAutorizacionREST(referencia, importeCentimos, merchant_parameters_recibidos) {

      //-- Definir recursos necesarios
      const {
          Redsys,
          SANDBOX_URLS,
          PRODUCTION_URLS,
          //TRANSACTION_TYPES,
          //randomTransactionId
      } = require('redsys-easy')

      //-- Extraer valores a utilizar en este Método
      var indiceTPV             = this.$store.state.strT001M030_Indice;  // Valores : 1, 2, ..., n
      if (indiceTPV > 0) { indiceTPV = indiceTPV - 1; }                  // Aplicar : 0, 1, ..., n-1

      //-- Extraer Datos de la Tarjeta
      let txtDatosTarjeta       = this.f75DesofuscarTexto(this.$store.state.strTPVMensajeTitulo);
      var aDatosTarjeta         = txtDatosTarjeta.split("^");
      let tPAN                  = aDatosTarjeta[0];
      let tExpiry               = aDatosTarjeta[1];
      let tCVV                  = aDatosTarjeta[2];

      //-- Datos del Comercio
      var secretTPV             = this.f75DesofuscarTexto(this.$store.state.strT001M030[indiceTPV].secretComercio);
      var codigoComercioTPV     = this.$store.state.strT001M030[indiceTPV].codigoComercio;
      var terminalComercioTPV   = this.$store.state.strT001M030[indiceTPV].terminalComercio;
      var urlConfirmacionOnline = this.$store.state.strT001M030[indiceTPV].urlConfirmacionOnline.replace('redsys','rest');

      //-- Determinar SI se ha recibido una URL para la verificación 3DSMethod
      let threeDSCompInd = 'N';
      if ((merchant_parameters_recibidos.Ds_EMV3DS) && (merchant_parameters_recibidos.Ds_EMV3DS.threeDSCompInd)) { threeDSCompInd = 'Y'; }

      //-- URLs TPV Virtual : Prueba ó Producción
      var URLsTPV   = SANDBOX_URLS;
      if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  URLsTPV = PRODUCTION_URLS; }

      //-- Comenzar la creación del OBJETO a enviar al TPV
      const redsys = new Redsys({
          secretKey:  secretTPV,
          urls:       URLsTPV, 
      });

      //-- Tipo de Transacción
      let tipoTransaccion = '0';                                          //-- Autorización para el Cargo

      //-- Construir nuevo Objeto REDSYS
      const obj = {
          order: referencia,                                              //-- Número de Referencia               
          merchantCode: codigoComercioTPV,                                //-- Código de la Tienda / Comercio
          terminal: terminalComercioTPV,                                  //-- Número de Terminal
          currency: 'EUR',                                                //-- Moneda
          transactionType: tipoTransaccion,                               //-- Tipo de Transacción
          amount: importeCentimos,                                        //-- Importe (en Céntimos de Euro)
          merchantURL: urlConfirmacionOnline,                             //-- URL del Comercio
          pan : tPAN,
          expiryDate : tExpiry,
          cvv : tCVV,            

          EMV3DS : '{ "threeDSInfo":"AuthenticationData", "protocolVersion":"2.1.0", \
                      "browserAcceptHeader":"text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8,application/json", \
                      "browserUserAgent":"Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/71.0.3578.98 Safari/537.36", \
                      "browserJavaEnabled":"false", "browserJavascriptEnabled":"true","browserLanguage":"ES-es",\
                      "browserColorDepth":"24","browserScreenHeight":"1250", "browserScreenWidth":"1320", "browserTZ":"52", \
                      "threeDSServerTransID":"'+merchant_parameters_recibidos.Ds_EMV3DS.threeDSServerTransID+'", \
                      "notificationURL":"'+urlConfirmacionOnline+'", \
                      "threeDSCompInd":"'+threeDSCompInd+'"}'
      }        

      /*
      console.log('');
      console.log('****** threeDSServerTransID ******');
      console.log(merchant_parameters_recibidos.Ds_EMV3DS.threeDSServerTransID);
      */

      //-- Debug
      const result = redsys.RESTPetition(obj);
      //console.log(result);

      //-- Determinar la URL
      this.ltURL = 'https://sis-t.redsys.es:25443/sis/rest/trataPeticionREST';
      if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  this.ltURL = 'https://sis.redsys.es/sis/rest/trataPeticionREST'; }

      //-- Establecer Valor para las variables del Formulario
      //this.ltURL                  = result.url;
      this.ltSignatureVersion     = result.body.Ds_SignatureVersion;
      this.ltMerchantParameters   = result.body.Ds_MerchantParameters;
      this.ltSignature            = result.body.Ds_Signature;

      //-- Efectuar el POST
      //setTimeout(() => {  this.$refs.TPVRedSys_Submit.click(); }, 100);      

      //-- TODO (Fase 2) - Enviar petición al servidor remoto, para que contacte con RedSys
      //-- Crear la URL para solicitar el Inicio de la Peticion

      //-- Valores Específicos del Pedido
      var referenciaPedido      = this.$store.state.strReferenciaPedido;
      var importePedido         = this.$store.state.strImportePedido;

      //-- Componer la URL
      let parametros = this.f75OfuscarTexto(this.ltURL+"|"+this.ltSignatureVersion+"|"+this.ltMerchantParameters+"|"+this.ltSignature+"|"+"(2)");
      let URL = global.lnkServerRestURL+"s="+this.$store.state.strIDSesion+"&d="+this.$store.state.strDistribuidor+"&u="+this.$store.state.strUsuario+'&r='+encodeURIComponent(referenciaPedido)+'&i='+encodeURIComponent(importePedido)+'&x='+encodeURIComponent(parametros);
      //console.log(URL);

      //-- Mostrar el/los indicadores de actividad oportunos
      this.$store.commit('p10StrRecibiendoDatos', true);
        
      //-- Solicitud de Datos al Servidor 
      axios.get(URL, {responseEncoding: 'utf-8'})
      .then(respuesta => {
      
            //console.log('Respuesta : ');
            //console.log(respuesta.data);

            //-- Desactivar los Indicadores de Actividad
            this.$store.commit('p10StrRecibiendoDatos', false);

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si el contenido es el correcto
            if (datos.ic2_rest) {
              /*
              console.log('EXITO');
              console.log('------------------');
              console.dir(datos.ic2_rest);
              console.log('------------------');
              */

              //-- Determinar si se ha recibido en mensaje CON ERRORES
              if (datos.ic2_rest.m001_codigoError == '') {
                //console.log(' *** EXITO ***');
                //-- Extraer los 3 valores recibidos
                //let m001_Signature            = datos.ic2_rest.m001_Signature;
                //let m001_Signature_Version    = datos.ic2_rest.m001_Signature_Version;
                let m001_Merchant_Parameters  = JSON.parse(this.f75DesofuscarTexto(datos.ic2_rest.m001_Merchant_Parameters));

                //-- Debug
                /*
                console.log('---------- B -------------');
                console.log(' m001_Signature : '+m001_Signature);
                console.log(' m001_Signature_Version : '+m001_Signature_Version);
                console.log('-- m001_Merchant_Parameters --');
                console.dir(m001_Merchant_Parameters);
                console.log('---- Fin B ----');
                */

                //....................................................
                //-- Evaluar si ya ha sido ACEPTADA (Frictionless)
                //....................................................
                if (m001_Merchant_Parameters.Ds_Response) {
                  //-- Mostrar formulario de PAGO CONFIRMADO
                  this.lp79AutorizacionConfirmada(m001_Merchant_Parameters);
                } else {
                  //-- Determinar si se han recibido los parámetros necesarios para el "Challenge"
                  if ((m001_Merchant_Parameters.Ds_EMV3DS) && (m001_Merchant_Parameters.Ds_EMV3DS.threeDSInfo)) {
                  //-- Solicitar el "Challenge"
                    this.lp73PeticionChallengeREST(m001_Merchant_Parameters.Ds_EMV3DS.acsURL, m001_Merchant_Parameters.Ds_EMV3DS.creq);
                  } else {
                    //-- Preparativos para mostrar el ERROR
                    this.ltCodigoError            = 'IC2001';
                    this.ltDescripcionError       = 'Respuesta Desconocida';

                    //-- Mostrar Mensaje de Error
                    this.lbMostrarFormularioPago  = false;
                    this.lbMostrarFormularioError = true;
                  }
                }

              } else {
                //-- Preparativos para mostrar el ERROR
                this.ltCodigoError            = datos.ic2_rest.m001_codigoError;
                this.ltDescripcionError       = datos.ic2_rest.m001_descripcionError;

                //-- Casos Especiales en los que se puede aportar un mensaje "más humano"
                if (this.ltCodigoError == 'SIS0252') { this.ltDescripcionError = 'Por su configuración no puede enviar la tarjeta. (Para modificarlo consultar con la entidad)'; }

                //-- Mostrar Mensaje de Error
                this.lbMostrarFormularioPago  = false;
                this.lbMostrarFormularioError = true;
              } 

            } else {
                this.p99AnuncioIH1('2','7','ERROR', 'Error TPV92000-B<br/>'+respuesta.data.msg,-1);
            }
                
      })
      .catch(error => {
          //-- Desactivar los Indicadores de Actividad
          this.$store.commit('p10StrRecibiendoDatos', false);

          //-- Mostrar el Mensaje de Error oportuno
          this.p99AnuncioIH1('2','7','ERROR', error.message,-1);
      });

      
    },


    //------------------------------------------------------------------------
    //-- REST (3) - Solicitud del "Challenge" al propietario de la Tarjeta
    //------------------------------------------------------------------------
    lp73PeticionChallengeREST(url, creq) {

      //-- Autorellenar el Formulario para el "Challenge"
      this.ltURLChallenge               = url;
      this.ltCREQChallenge              = creq;

      //-- Mostrar Formulario
      this.lbMostrarFormularioPago      = false;
      this.lbMostrarFormularioChallenge = true;

      //-- Ejecutar el (Submit) para la ejecución
      setTimeout(() => {  this.$refs.TPVRedSys_Submit_CREQ.click(); }, 50);      

    },

    //---------------------------------------------------------------
    //-- Confirmar la OPERACION, una vez recibido el (OK) de RedSys
    //---------------------------------------------------------------
    lp75ConfirmarAutorizacion() {
      //console.log('-- lp75ConfirmarAutorizacion --');

      //-- Cargar Variables Globales
      this.ltReferenciaPedido                         = this.$store.state.strReferenciaPedido;
      this.ltCodigoAutorizacion                       = '??????';
      this.lnImportePago                              = parseInt(this.$store.state.strImportePedido, 10) / 100;

      //-- Mostrar ÚNICAMENTE el formulario de Pre-Confirmación
      this.lbMostrarFormularioPago                    = false;
      this.lbMostrarFormularioChallenge               = false;
      this.lbMostrarFormularioError                   = false;
      this.lbMostrarFormularioPreConfirmacion         = true;
      this.lbMostrarFormularioOperacionConfirmada     = false;

      //-- Definir recursos necesarios
      const {
          Redsys,
          SANDBOX_URLS,
          PRODUCTION_URLS,
          //TRANSACTION_TYPES,
          //randomTransactionId
      } = require('redsys-easy')

      //-- Extraer valores a utilizar en este Método
      var indiceTPV             = this.$store.state.strT001M030_Indice;  // Valores : 1, 2, ..., n
      if (indiceTPV > 0) { indiceTPV = indiceTPV - 1; }                  // Aplicar : 0, 1, ..., n-1

      //-- Extraer Datos de la Tarjeta
      let txtDatosTarjeta       = this.f75DesofuscarTexto(this.$store.state.strTPVMensajeTitulo);
      var aDatosTarjeta         = txtDatosTarjeta.split("^");
      let tPAN                  = aDatosTarjeta[0];
      let tExpiry               = aDatosTarjeta[1];
      let tCVV                  = aDatosTarjeta[2];

      //-- Valores para Encriptar el Mensaje
      var secretTPV             = this.f75DesofuscarTexto(this.$store.state.strT001M030[indiceTPV].secretComercio);
      var codigoComercioTPV     = this.$store.state.strT001M030[indiceTPV].codigoComercio;
      var terminalComercioTPV   = this.$store.state.strT001M030[indiceTPV].terminalComercio;

      //-- URLs TPV Virtual : Prueba ó Producción
      var URLsTPV   = SANDBOX_URLS;
      if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  URLsTPV = PRODUCTION_URLS; }

      //-- Comenzar la creación del OBJETO a enviar al TPV
      const redsys = new Redsys({
          secretKey:  secretTPV,
          urls:       URLsTPV, 
      });

      //-- Tipo de Transacción
      let tipoTransaccion = '0';                                          //-- Autorización para el Cargo

      //-- Construir nuevo Objeto REDSYS
      const obj = {
          order: this.$store.state.strReferenciaPedido,                   //-- Número de Referencia               
          merchantCode: codigoComercioTPV,                                //-- Código de la Tienda / Comercio
          terminal: terminalComercioTPV,                                  //-- Número de Terminal
          currency: 'EUR',                                                //-- Moneda
          transactionType: tipoTransaccion,                               //-- Tipo de Transacción
          amount: this.$store.state.strImportePedido,                     //-- Importe (en Céntimos de Euro)
          pan : tPAN,                                                     //-- PAN de la Tarjeta
          expiryDate : tExpiry,                                           //-- Caducidad de la Tarjeta
          cvv : tCVV,                                                     //-- CVV de la Tarjeta

          EMV3DS : '{ "threeDSInfo":"ChallengeResponse", \
                      "protocolVersion":"2.1.0", \
                      "cres":"'+this.$store.state.strTPVMensajeSubtitulo+'"}'
      }        

      //-- Debug
      const result = redsys.RESTPetition(obj);
      //console.log(result);

      //-- Determinar la URL
      this.ltURL = 'https://sis-t.redsys.es:25443/sis/rest/trataPeticionREST';
      if (this.$store.state.strT001M030[indiceTPV].modoProduccion) {  this.ltURL = 'https://sis.redsys.es/sis/rest/trataPeticionREST'; }

      //-- Establecer Valor para las variables del Formulario
      this.ltSignatureVersion     = result.body.Ds_SignatureVersion;
      this.ltMerchantParameters   = result.body.Ds_MerchantParameters;
      this.ltSignature            = result.body.Ds_Signature;

      //..........................................................
      //-- Crear la URL para solicitar el Inicio de la Peticion
      //..........................................................

      //-- Valores Específicos del Pedido
      var referenciaPedido      = this.$store.state.strReferenciaPedido;
      var importePedido         = this.$store.state.strImportePedido;      

      //-- Componer la URL para solicitar la CONFIRMACION  @#@#@#
      let parametros = this.f75OfuscarTexto(this.ltURL+"|"+this.ltSignatureVersion+"|"+this.ltMerchantParameters+"|"+this.ltSignature+"|"+"(5)");
      let URL = global.lnkServerRestURL+"s="+this.$store.state.strIDSesion+"&d="+this.$store.state.strDistribuidor+
                "&u="+this.$store.state.strUsuario+'&c='+this.$store.state.strCliente+'&n='+this.$store.state.strNifClienteOfuscado+
                '&r='+encodeURIComponent(referenciaPedido)+'&i='+encodeURIComponent(importePedido)+'&x='+encodeURIComponent(parametros);
      //console.log(URL);

      //-- Mostrar el/los indicadores de actividad oportunos
      this.$store.commit('p10StrRecibiendoDatos', true);
        
      //-- Solicitud de Datos al Servidor 
      axios.get(URL, {responseEncoding: 'utf-8'})
      .then(respuesta => {
      
            //console.log('Respuesta : ');
            //console.log(respuesta.data);

            //-- Desactivar los Indicadores de Actividad
            this.$store.commit('p10StrRecibiendoDatos', false);

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si el contenido es el correcto
            if (datos.ic5_rest) {
              /*
              console.log('EXITO');
              console.log('------------------');
              console.dir(datos.ic5_rest);
              console.log('------------------');
              */

              //-- Determinar si se ha recibido en mensaje CON ERRORES
              if (datos.ic5_rest.m001_codigoError == '') {
                //console.log(' *** EXITO ***');

                //-- Extraer los 3 valores recibidos
                //let m001_Signature            = datos.ic5_rest.m001_Signature;
                //let m001_Signature_Version    = datos.ic5_rest.m001_Signature_Version;
                let m001_Merchant_Parameters  = JSON.parse(this.f75DesofuscarTexto(datos.ic5_rest.m001_Merchant_Parameters));

                //-- Debug
                /*
                console.log('---------- E -------------');
                console.log(' m001_Signature : '+m001_Signature);
                console.log(' m001_Signature_Version : '+m001_Signature_Version);
                console.log('-- m001_Merchant_Parameters --');
                console.dir(m001_Merchant_Parameters);
                console.log('---- Fin E ----');
                */

                //............................................
                //-- Evaluar si la petición ha sido ACEPTADA 
                //............................................
                if (m001_Merchant_Parameters.Ds_Response) {
                  //-- Mostrar formulario de PAGO CONFIRMADO
                  this.lp79AutorizacionConfirmada(m001_Merchant_Parameters);
                } else {
                  //-- Preparativos para mostrar el ERROR
                  this.ltCodigoError            = 'IC5001';
                  this.ltDescripcionError       = 'Respuesta Desconocida';

                  //-- Mostrar Mensaje de Error
                  this.lbMostrarFormularioPago            = false;
                  this.lbMostrarFormularioPreConfirmacion = false;
                  this.lbMostrarFormularioError           = true;
                }

              } else {
                //-- Preparativos para mostrar el ERROR
                this.ltCodigoError                      = datos.ic5_rest.m001_codigoError;
                this.ltDescripcionError                 = datos.ic5_rest.m001_descripcionError;

                //-- Mostrar Mensaje de Error
                this.lbMostrarFormularioPago            = false;
                this.lbMostrarFormularioPreConfirmacion = false;
                this.lbMostrarFormularioError           = true;
              } 

            } else {
                this.p99AnuncioIH1('2','7','ERROR', 'Error TPV92000-E<br/>'+respuesta.data.msg,-1);
            }
                
      })
      .catch(error => {
          //-- Desactivar los Indicadores de Actividad
          this.$store.commit('p10StrRecibiendoDatos', false);

          //-- Mostrar el Mensaje de Error oportuno
          this.p99AnuncioIH1('2','7','ERROR', error.message,-1);
      });      

    },


    //------------------------------------------------------------------
    //-- Formulario FINAL, con los datos de la Operación YA CONFIRMADA
    //------------------------------------------------------------------
    lp79AutorizacionConfirmada(m001_Merchant_Parameters) {
      //console.log('-- lp79AutorizacionConfirmada --');

      //-- Cargar valor sobre Variables Globales
      this.ltReferenciaPedido                       = this.$store.state.strReferenciaPedido;
      this.lnImportePago                            = parseInt(this.$store.state.strImportePedido, 10) / 100;

      //-- Cargar Valores a mostrar en el Formulario de Confirmación
      if (m001_Merchant_Parameters.Ds_Response == '0000') {
        this.ltCodigoError              = '0';      
        this.ltMensajeError             = 'EXITO';  
      } else {
        this.ltCodigoError              = m001_Merchant_Parameters.Ds_Response;

        var errorHTML = decodeURIComponent(m001_Merchant_Parameters.Ds_Response_Description);
        this.ltMensajeError             = errorHTML;
      }

      //-- Fecha y Hora Actuales
      let ahora = new Date();
      let fecha = this.f92Date2DMA(ahora);
      let hora  = this.f92Date2HMS(ahora);

      //-- Atributos Públicos
      this.ltCodigoTienda             = m001_Merchant_Parameters.Ds_MerchantCode;
      this.ltCodigoTerminal           = m001_Merchant_Parameters.Ds_Terminal;
      this.ltTipoTransaccion          = m001_Merchant_Parameters.Ds_TransactionType;
      this.ltFechaAutorizacion        = fecha.replaceAll('-','/');
      this.ltHoraAutorizacion         = hora.substr(0,5);
      this.ltTipoTarjeta              = m001_Merchant_Parameters.Ds_Card_Brand;
      this.ltPaisTarjeta              = m001_Merchant_Parameters.Ds_Card_Country;
      this.ltMonedaOperacion          = m001_Merchant_Parameters.Ds_Currency;
      this.ltImporteOperacion         = m001_Merchant_Parameters.Ds_Amount;
      this.ltReferenciaERP            = m001_Merchant_Parameters.Ds_Order;
      this.ltPagoSeguro               = m001_Merchant_Parameters.Ds_SecurePayment;
      this.ltPANTarjeta               = m001_Merchant_Parameters.Ds_CardNumber;
      this.ltCaducidadTarjeta         = '';
      this.ltIdentificadorTarjeta     = '';
      this.ltIdiomaUsuario            = m001_Merchant_Parameters.Ds_Language;
      this.ltReferenciaPedido         = m001_Merchant_Parameters.Ds_Order;
      this.ltCodigoAutorizacion       = m001_Merchant_Parameters.Ds_AuthorisationCode;
      this.lnImportePago              = parseInt(m001_Merchant_Parameters.Ds_Amount, 10) / 100;

      //-- Mostrar Formulario
      this.lbMostrarFormularioPago                  = false;
      this.lbMostrarFormularioChallenge             = false;
      this.lbMostrarFormularioError                 = false;
      this.lbMostrarFormularioPreConfirmacion       = false;
      this.lbMostrarFormularioOperacionConfirmada   = true;
    },



    //------------------------------------------------------
    //-- Reclamar Lista de TPV Virtuales disponibles
    //------------------------------------------------------
    lp98t001m030() {
      
      var URL = global.lnkServerAppURL + "&s="+this.$store.state.strIDSesion+"&d="+this.$store.state.strDistribuidor+"&u="+this.$store.state.strUsuario+"&t=001&m=030";
      //console.log(URL);

      //-- Mostrar el/los indicadores de actividad oportunos
      this.$store.commit('p10StrRecibiendoDatos', true);
        
      //-- Solicitud de Datos al Servidor 
      axios.get(URL, {responseEncoding: 'utf-8'})
      .then(respuesta => {
      
            //console.log('Respuesta : ');
            //console.log(respuesta.data);

            //-- Desactivar los Indicadores de Actividad
            this.$store.commit('p10StrRecibiendoDatos', false);

            //-- Extraer la respuesta recibida
            var datos = respuesta.data;

            //-- Determinar si el contenido es el correcto
            if (datos.t001m030) {
              //-- Debug
              /*
               console.log('-- Lista de TPVs OK --');
               console.log('** Array **');
               console.dir(datos.t001m030);
               console.log('** Índice **');
               console.dir(datos.t001m030_indice);
               console.log('----------------------');
              */
              
              //-- Actualizar Información relacionada con los TPVs
              this.$store.commit('p10StrT001M030',        datos.t001m030);
              this.$store.commit('p10StrT001M030_Indice', datos.t001m030_indice);

              //var i = this.$store.state.strT001M030_Indice;
              //console.log(' (A) Índice = '+i);

              //console.log(' this.$store.state.strTPVMensajeSubtitulo = '+this.$store.state.strTPVMensajeSubtitulo);
   
              //........................................................................
              //-- Determinar si se trata de un INICIO ó FINALIZACIÓN de la Operación
              //........................................................................
              if (this.$store.state.strTPVMensajeSubtitulo == '') {
                //-- Solicitar Autorización para el PAGO (Inicio)           [Fase 0]
                this.lp50IniciarTransaccion();
              } else {
                //-- Ejecutar Confirmación del PAGO (para su Finalización)  [Fase 5]
                  this.lp75ConfirmarAutorizacion();
              } 

            } else {
                this.p99AnuncioIH1('2','7','ERROR', 'Error TPV92000<br/>'+respuesta.data.msg,-1);
            }
                
        })
        .catch(error => {
          //-- Desactivar los Indicadores de Actividad
          this.$store.commit('p10StrRecibiendoDatos', false);

          //-- Mostrar el Mensaje de Error oportuno
          this.p99AnuncioIH1('2','7','ERROR', error.message,-1);
        });

    }

  },

  //=======================================================================
  //------------ Métodos a aplicar una vez CARGADA la Página  -------------
  //=======================================================================
  mounted() {
    //console.log('SVC92000 mounted');

    //-- Conservar el Valor de (strTPVMerchantIdentifier)
    this.ltSavedTPVMerchantIdentifier = this.$store.state.strTPVMerchantIdentifier;
    //console.log('ltSavedTPVMerchantIdentified = ('+this.$store.state.strTPVMerchantIdentifier+')');

    //-- Mostrar Leyenda "Guardar Tarjeta"
    //if ((this.ltSavedTPVMerchantIdentifier == '') && (this.$store.state.strTPVMerchantPayMethods != 'z')) { this.lbMostrarGuardarTarjeta    = true; }

    //-- Mostrar Leyenda "Se va a utilizar la siguiente tarjeta ..."
    //if ((this.ltSavedTPVMerchantIdentifier != '') && (this.$store.state.strTPVMerchantPayMethods != 'z')) { this.lbMostrarTarjetaGuardada   = true; }

    //-- Determinar si se trata de una Operación de Autenticación (Pre-Autorización para Cargo Posterior)
    if (this.$store.state.strTPVMerchantPayMethods == '1') { this.lbOperacionAutenticacion  = true; }  //-- PreAutorización  (CON Bloqueo de Importe en Cuenta del Cliente)
    if (this.$store.state.strTPVMerchantPayMethods == '7') { this.lbOperacionAutenticacion  = true; }  //-- PreAutenticación (SIN Bloqueo de Importe en Cuenta del Cliente)

    //-- Determinar si se trata de una Operación BIZUM (o no)
    //if (this.$store.state.strTPVMerchantPayMethods == 'z') { this.lbOperacionBizum          = true; }

    //this.lp50IniciarTransaccion();
    this.lp98t001m030();

  }
}


/*
================================================================================================================================================
    DATOS GENÉRICOS DE PRUEBA
================================================================================================================================================

        Para la realizacion de pruebas, cada comercio debe utilizar sus valores facilitados por su entidad para lo siguientes parámetros:

            (1) Número de comercio (Ds_Merchant_MerchantCode)
            (2) Terminal (Ds_Merchant_Terminal)
            (3) Clave secreta

    ..............................................................................................................................................

        Tarjeta aceptada:
            Numeración: 4548 8100 0000 0003
            Caducidad: 12/49
            Código CVV2: 123

        En modo de compra segura (CES), en la que se requiera autenticación del comprador, el código de identificación personal (CIP) es: 
            123456


    ..............................................................................................................................................

        Tarjeta rechazada:
            Numeración: 5576 4400 2278 8500
            Caducidad: 12/49
            Código CVV2: 123

        En modo de compra segura (CES), en la que se requiera autenticación del comprador, el código de identificación personal (CIP) es: 
            123456

*/

</script>

<style type="scope">
</style>

